import { createSlice } from "@reduxjs/toolkit"
//import axios from 'axios';


const dt = new Date()
const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
const day = dt.getUTCDate();
const month = String(dt.getMonth() + 1).padStart(2, '0');
const year = dt.getFullYear();
const date = year + "-" + month + "-" + day;

let data = []

if (localStorage.getItem("Class") !== null && localStorage.getItem("Class") !== undefined && localStorage.getItem("Class") !== "") {
    try {
        const parsed = JSON.parse(localStorage.getItem("Class"))
        // Store a flat list of class documents (do not wrap an array in another array)
        if (Array.isArray(parsed)) {
            data = parsed
        } else if (parsed && typeof parsed === 'object') {
            data = [parsed]
        }
    } catch (e) {
        data = []
    }
}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {

        getdata_: (state, action) => {

            return action.payload.data || [];

        },

        logout_: (state, action) => {


            localStorage.clear()
            state = []


        },

        updateclassdata: (state, action) => {


            return action.payload.data || [];

        },


    }
})

export const { logout_, updateclassdata, login, getdata_ } = Insider.actions;
export default Insider.reducer;